import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { ConsoleService } from "src/app/shared/services/console.service";
import { RutService } from 'src/app/shared/services/rut.service';
import * as _ from 'lodash'

@Component({
  selector: 'app-modal-doc-procesado-resultado',
  templateUrl: './modal-doc-procesado-resultado.component.html',
  styleUrls: ['../../empresas-recibidos.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class ModalDocumentoProcesadoResultadoComponent implements OnInit {

  // Modales
  @ViewChild('documentoProcesadoResultado', { static: true }) documentoProcesadoResultadoModal: ModalDirective;

  formPrecioCosto: FormGroup;

  //Cabecera
  listaMovimientos: Array<any> = null;

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private rutService: RutService,
    private clog: ConsoleService,
  ) {
    this.log = this.clog.log('DOCUMENTO-PROCESADO-RESULTADO-VIEW')
  }

  ngOnInit() {
    
  }

  loadAndShow(documento:any) {
    this.selectData(documento)
    this.show()
  }

  show() {
    //this.isEditing = false
    this.documentoProcesadoResultadoModal.show()
  }

  hide() {
    this.documentoProcesadoResultadoModal.hide()
  }

  selectData(documento){
    this.listaMovimientos = documento;
    this.listaMovimientos.forEach((mov) => {
      mov.rutFormato = this.rutService.AgregarDV(mov.rut_emisor)
    })
  }
}
